import { createSlice, freeze, PayloadAction } from '@reduxjs/toolkit';
import { ITileFieldsFragment } from '../../../utils/apollo/graphqlSchema';
import { assertCondition } from '../../../utils/types';
import { TileSlice } from './types';

const initialState = freeze<TileSlice>(
  {
    tiles: [],
  },
  true,
);

export default createSlice({
  name: 'tiles',
  initialState,
  reducers: {
    populateTiles: (draft, action: PayloadAction<ITileFieldsFragment[]>) => {
      draft.tiles = action.payload;
    },
    resetTiles: () => {
      return initialState;
    },
    deleteTile: (draft, action: PayloadAction<{ id: string }>) => {
      const { id } = action.payload;
      assertCondition(draft.tiles.length > 0);
      draft.tiles = draft.tiles.filter((tile) => tile.id !== id);
    },
    addTile: (draft, action: PayloadAction<ITileFieldsFragment>) => {
      draft.tiles.push(action.payload);
    },
    updateTile: (draft, action: PayloadAction<ITileFieldsFragment>) => {
      const updatedTile = action.payload;
      assertCondition(draft.tiles.length > 0);

      const tileIndex = draft.tiles.findIndex(
        (tile) => tile.id === updatedTile.id,
      );

      if (tileIndex !== -1) {
        draft.tiles[tileIndex] = updatedTile;
      }
    },
  },
});
